// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"145":"826f4891","213":"8a817128","270":"26e3475d","590":"5dcc2440","970":"9573fc91","983":"116cfa50"}[chunkId] + ".chunk.css";
};